import React, { Suspense } from "react";
import { ECLPageWrapper, ECLLoader } from "../../../eclComponents";
import { Link } from "react-router-dom";

export default function TestLoader(props) {
   return (
      <Suspense fallback={<ECLLoader />}>
         <ECLPageWrapper>
            <div
               style={{
                  borderBottom: "solid 1px grey",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
               }}
            >
               <h2 className="test-loader-header">Test Loaded Successfully</h2>
               <Link to={"/sourceone/testing"}>Back to Testing Home Page</Link>
            </div>
            <h3>{props.title} Tests</h3>
            {props.children}
         </ECLPageWrapper>
      </Suspense>
   );
}
